import { AxiosResponse } from "axios";

import { ReportInvoiceShipment, Shipment } from "../models/shipments";

import API from "../api";

import { GetAndCountAll } from "./_base";
import { Network } from "../models/network";

const ROUTE_NAME = "bookings";

const ShipmentBookingService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Shipment>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async getAllNetwork(options?: any): Promise<AxiosResponse<GetAndCountAll<Shipment>>> {
    return await API.get(`/${ROUTE_NAME}/network`, { params: options });
  },
  async getAvailable(options?: any): Promise<AxiosResponse<GetAndCountAll<Shipment>>> {
    return await API.get(`/${ROUTE_NAME}/available/list`, { params: options });
  },
  async getNetworkInfos(options?: any): Promise<AxiosResponse<Network[]>> {
    return await API.get(`/${ROUTE_NAME}/network/info`, { params: options });
  },
  // temporary endpoint to test shipment ms
  async create(shipment: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, shipment);
  },
  async update(id: number, booking: any): Promise<AxiosResponse<any>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, booking);
  },

  async getBookingFile(shipmentId: number): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/reports/booking/file`, { shipmentId });
  },
  async getBookingFiles(shipmentList: number[]): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}/reports/booking/file/zip`, { shipmentList });
  },

  async receivedAllBookings(bookingIds: number[]): Promise<AxiosResponse<any>> {
    return await API.put(`/v3/${ROUTE_NAME}/receive/bookings`, { bookingIds });
  },

  async cancelBooking(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/cancel/${id}`);
  },

  async reviewByCfs(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/review/cfs/${id}`);
  },

  async sendBookingFilesMods(bookingIds: number[]): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/send/mods`, { bookingIds });
  },

  async getInvoiceList(
    options?: any
  ): Promise<AxiosResponse<GetAndCountAll<ReportInvoiceShipment>>> {
    return await API.get(`/${ROUTE_NAME}/invoice/list`, { params: options });
  },
};

export default ShipmentBookingService;
